import { ValidatorFn, Validators } from '@angular/forms';

/** Las etiquetas RFID (EPC) del proyecto siempre tienen 24 caracteres. */
export const RFID_TAG_LENGTH = 24;

export const RFID_TAG_LABEL = `Etiqueta RFID (${RFID_TAG_LENGTH} caracteres)`;

export const RFID_TAG_ERROR = `La etiqueta RFID debe tener exactamente ${RFID_TAG_LENGTH} caracteres.`;

/** Validadores de longitud exacta para un control de etiqueta RFID. */
export function rfidTagValidators(required = false): ValidatorFn[] {
  const v: ValidatorFn[] = [Validators.minLength(RFID_TAG_LENGTH), Validators.maxLength(RFID_TAG_LENGTH)];
  return required ? [Validators.required, ...v] : v;
}

export function isValidRfidTag(tag: string | null | undefined): boolean {
  return String(tag ?? '').trim().length === RFID_TAG_LENGTH;
}
